import { RootStore } from "./rootStore";
import { makeAutoObservable, observable, action } from "mobx";

export default class ButtonLoadingStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable loading = false;

  @action changeState = () => {
    this.loading = !this.loading;
  };
}
